module.exports = __webpack_public_path__ + "img/non-graphical-email.7de39706.png";